import { styled } from '@mui/system';

const FlexColCenter = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

export default FlexColCenter;
